import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TileSetTypeSelectComponent } from './container/tile-set-type-select.component';
import { TileSetTypeSelectEffects } from './state/tile-set-type-select.effects';
import * as fromTileSetTypeSelect from './state/tile-set-type-select.reducer';
import { TileSetTypeSelectViewComponent } from './view/tile-set-type-select-view.component';

@NgModule({
   declarations: [TileSetTypeSelectComponent, TileSetTypeSelectViewComponent],
   exports: [TileSetTypeSelectComponent, TileSetTypeSelectViewComponent],
   imports: [
      CommonModule,
      MatSelectModule,
      MatFormFieldModule,
      StoreModule.forFeature(fromTileSetTypeSelect.tileSetTypeSelectFeatureKey, fromTileSetTypeSelect.reducer),
      EffectsModule.forFeature([TileSetTypeSelectEffects]),
   ],
})
export class TileSetTypeSelectModule {}
